// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"e2","imgTextCardBox":"e2","text-box":"e3","textBox":"e3","remark-val":"e4","remarkVal":"e4"};